import React from 'react';
import {
  BodyText,
  Message,
  Stack,
  Subtitle,
  TinyTitleRegular
} from '@kvdbil/components';
import { useTranslation } from '~/Locale';
import { EligibilityResult } from './eligibility';
import { ResultContainer, BulletList } from './styles';

interface Props {
  result: EligibilityResult | null;
}

const ElectricCarGrantResult = ({ result }: Props) => {
  const { t } = useTranslation();

  if (!result) {
    return null;
  }

  return (
    <ResultContainer aria-live="polite" id="electric-car-grant-result">
      <Stack spacing={1.5} direction="column">
        <Subtitle>{t('Result (preliminary assessment):')}</Subtitle>
        {result.eligible && (
          <Stack>
            <Message type="success" fullWidth>
              <Stack>
                <BodyText>
                  {t(
                    'Based on your answers, you appear to meet the preliminary requirements for the electric car premium.'
                  )}
                </BodyText>
                <BodyText>
                  {t(
                    'Preliminary support: 1,300 SEK/month up to 46,800 SEK in total'
                  )}
                </BodyText>
              </Stack>
            </Message>
            <Message type="info" withIcon fullWidth>
              <BodyText>
                {t(
                  'The exact premium amount will be determined by Naturvårdsverket.'
                )}
              </BodyText>
            </Message>
          </Stack>
        )}

        {!result.eligible && (
          <Message type="error" fullWidth>
            <Stack>
              <BodyText>
                {t('It looks like you do not meet all requirements right now')}
              </BodyText>

              <TinyTitleRegular>
                {t('Reasons that may affect:')}
              </TinyTitleRegular>
              <BulletList role="list">
                {result.reasons.map(reason => (
                  <li key={reason}>{reason}</li>
                ))}
              </BulletList>
            </Stack>
          </Message>
        )}
      </Stack>
    </ResultContainer>
  );
};

export default ElectricCarGrantResult;
